import React, { useState } from 'react';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { isEmpty } from 'fast-glob/out/utils/string';
import { useTheme } from 'styled-components';
import { SearchPlusIcon } from 'assets/icons';
import { Flex, Icon, MarginBox } from 'UI';
import { SReferenceInput } from './ReferenceInput.styled';

interface ReferenceInputProps {
  placeholder?: string;
  initialValue?: string;
  onConfirm: (val: string) => void;
  expandable?: boolean;
  size?: SizeType;
}

const sizeToIconSize: Record<NonNullable<SizeType>, number> = {
  small: 16,
  middle: 20,
  large: 22,
};

export function ReferenceInput({
  placeholder,
  initialValue,
  onConfirm,
  expandable,
  size,
}: Readonly<ReferenceInputProps>) {
  const theme = useTheme();
  const [referenceToAdd, setReferenceToAdd] = useState(initialValue ?? '');

  function handleConfirm(val: string) {
    const trimmedVal = val.trim();
    if (isEmpty(trimmedVal)) return;
    onConfirm(trimmedVal);
    setReferenceToAdd('');
  }

  return (
    <SReferenceInput
      placeholder={placeholder}
      initialValue={initialValue}
      value={referenceToAdd}
      onChange={setReferenceToAdd}
      onPressEnter={handleConfirm}
      bordered={true}
      expandable={expandable}
      size={size}
      data-cy={'add-reference-to-your-cart-text-field'}
      prefix={
        <Flex>
          <Icon
            onClick={() => handleConfirm(referenceToAdd)}
            IconComponent={SearchPlusIcon}
            size={size ? sizeToIconSize[size] : 25}
            color={theme.color.grey55}
            data-cy={'add-reference-to-your-cart-confirm-icon'}
          />
          <MarginBox mr={10} />
        </Flex>
      }
    />
  );
}
